<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-skip-next`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.585 12.145a1 1 0 00-1.585.81v22.09a1 1 0 001.585.81L28.878 24.81a1 1 0 000-1.622L13.585 12.145z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33 36a1 1 0 01-1-1V13a1 1 0 011-1h2a1 1 0 011 1v22a1 1 0 01-1 1h-2z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSkipNext',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
